// src/layout/spacing.ts
function getSpacingVariable(size) {
  return `var(--hds-spacing-${size})`;
}

export {
  getSpacingVariable
};
//# sourceMappingURL=chunk-NE6W2PCD.mjs.map